var _defs, _sodipodiNamedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoringRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 581.26099,
    width: 800,
    viewBox: "0 0 439.479 319.315",
    enableBackground: "new 0 0 439.479 439.479",
    id: "svg470",
    sodipodidocname: "monitoring_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs474"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview472",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapezoom: 1.03375,
    inkscapecx: 400,
    inkscapecy: 290.20556,
    "inkscapewindow-width": 3440,
    "inkscapewindow-height": 1302,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent--layer": "g468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g468",
    transform: "translate(0,-60.082)",
    style: {
      stroke: "none",
      strokeOpacity: 0,
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.79313852,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 407.18,60.082 H 32.298 C 14.488,60.082 0,74.571 0,92.381 v 226.626 c 0,17.81 14.488952,31.01615 32.298,31.2003 h 108.4494 l -12.162,16.3871 H 108.158 c -4.143,0 -7.5,2.2593 -7.5,6.4013 0,4.142 3.357,6.4013 7.5,6.4013 H 331.32 c 4.143,0 7.5,-2.2593 7.5,-6.4013 0,-4.142 -3.357,-6.4013 -7.5,-6.4013 H 310.8926 L 298.7306,351.306 407.18,350.2073 c 17.80909,-0.18042 32.299,-13.3903 32.299,-31.2003 V 92.381 c 0,-17.81 -14.49,-32.299 -32.299,-32.299 z M 15,310.504 13.901302,99.785302 H 425.5777 V 311.6037 L 15,310.505 Z M 31.766586,72.423932 407.18,72.883605 c 7.23999,0.0089 14.5457,7.771093 17.1197,14.097093 H 15.178302 c 2.575,-6.325 9.34829,-14.565631 16.588284,-14.556766 z M 294.8134,366.5924 H 144.6646 l 12.162,-16.3871 H 282.6514 Z M 407.18,337.4037 H 32.298 c -7.24,0 -14.544698,-6.6724 -17.119698,-12.9984 H 424.2997 c -2.575,6.325 -9.8797,12.9984 -17.1197,12.9984 z",
    id: "path464",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.793139,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    sodipodinodetypes: "sssssccssssssccssssccccccssccscccccssccs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 373.0723,160.2357 c -9.064,-9.064 -21.6166,-9.065 -30.6816,0 -4.392,4.391 -6.811,9.1313 -6.811,15.3413 0,3.34 1.8197,6.562 3.1497,9.52 L 276.66,234.5014 c -6.806,-3.618 -16.1407,-3.618 -22.9457,0 l -60.9817,-48.3147 c 3.825,-8.549 3.3577,-18.944 -3.6493,-25.95 -9.065,-9.064 -21.6156,-9.066 -30.6826,0 -7.006,7.007 -8.573,16.3023 -4.748,24.8513 l -62.080398,49.4134 c -8.789,-4.672 -17.767604,-4.4157 -25.165604,2.9813 -9.064,9.065 -9.064,21.6166 0,30.6816 4.533,4.532 9.387302,6.799 15.340302,6.799 5.954,0 10.808302,-2.266 15.341302,-6.799 7.005998,-7.007 8.572998,-16.3023 4.747998,-24.8513 l 60.9817,-48.3147 c 3.403,1.809 7.162,2.719 10.923,2.719 3.762,0 7.521,0.1887 10.924,-1.6203 l 62.0804,47.216 c -3.825,8.549 -3.3577,17.8453 3.6493,24.8513 4.533,4.533 9.3863,6.798 15.3413,6.798 5.952,0 11.907,-1.1673 16.439,-5.6993 v 0 c 7.006,-7.007 6.3756,-17.401 2.5506,-25.95 l 62.0814,-49.4134 c 3.403,1.809 7.162,3.8177 10.924,3.8177 5.953,0 10.8073,-2.266 15.3403,-6.799 9.065,-9.065 9.065,-21.6176 10e-4,-30.6826 z M 87.58,258.656 c -3.214,3.216 -8.449,3.217 -11.665,0 -3.217,-3.217 -3.217,-8.45 0,-11.666 1.607,-1.608 3.72,-2.412 5.832,-2.412 2.113,0 4.226,0.804 5.833,2.412 3.217,3.216 3.217,8.45 0,11.666 z m 80.329,-77.246 c -3.217,-3.217 -3.217,-8.45 0,-11.666 1.607,-1.608 3.72,-2.412 5.832,-2.412 2.113,0 4.226,0.804 5.833,2.412 3.217,3.217 3.217,8.45 0,11.666 -3.213,3.216 -8.448,3.217 -11.665,0 z m 103.661,77.246 c -3.217,3.217 -8.452,3.216 -11.667,0 -3.217,-3.217 -3.217,-8.45 0,-11.666 1.607,-1.608 3.72,-2.412 5.833,-2.412 2.112,0 4.226,0.804 5.833,2.412 3.217,3.216 3.217,8.45 10e-4,11.666 z m 91.993,-77.246 c -3.215,3.216 -8.449,3.216 -11.666,0 -1.559,-1.558 -2.416,-3.629 -2.416,-5.833 0,-2.203 0.857,-4.275 2.417,-5.833 1.607,-1.608 3.72,-2.412 5.833,-2.412 2.112,0 4.225,0.804 5.832,2.412 3.217,3.216 3.217,8.449 0,11.666 z",
    id: "path466",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.793139,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    sodipodinodetypes: "ccsccccccccccscccscccsccccssccccsccscsccssccscsccscscc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringRed);
export default __webpack_public_path__ + "static/media/monitoring_red.70d30927.svg";
export { ForwardRef as ReactComponent };